/**
 * HTTP headers allow the client and the server to pass additional
 * information with the request or the response.
 *
 * Request header: Headers containing more information about the
 * resource to be fetched or about the client itself.
 */
const HEADERS = {
  Accept: 'application/json',
};

export default HEADERS;
